// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".link-list_e147 {\n  margin: 0 -1.25rem;\n  padding: 0.3125rem 0;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Sidebar/LinkList.scss","LinkList.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,oBAAA;ACDJ","file":"LinkList.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.link-list {\n    margin: 0 (-$space-20);\n    padding: $space-5 0;\n}\n",".link-list {\n  margin: 0 -1.25rem;\n  padding: 0.3125rem 0;\n}"]}]);
// Exports
exports.locals = {
	"link-list": "link-list_e147"
};
module.exports = exports;
